import { CountryCode } from "utils/mandators/enums";
import {
  FeatureFlagKey,
  type PartialFeatureFlags,
} from "../resolveFlags/featureFlags.type";

export const featureFlagsPROD: PartialFeatureFlags = {
  // WIZARDS
  [FeatureFlagKey.FIRE_PROTECTION_WIZARD]: {
    disabledTenants: [
      CountryCode.AT,
      CountryCode.ES,
      CountryCode.FR,
      CountryCode.CZ,
      CountryCode.SK,
      CountryCode.RO,
      CountryCode.HU,
    ],
  },
  [FeatureFlagKey.ROOM_CONTROL_WIRED_WIZARD]: {
    disabledTenants: [
      CountryCode.AT,
      CountryCode.ES,
      CountryCode.FR,
      CountryCode.CZ,
      CountryCode.SK,
      CountryCode.RO,
      CountryCode.HU,
    ],
  },
  [FeatureFlagKey.ROOM_CONTROL_WIRELESS_WIZARD]: {
    disabledTenants: [
      CountryCode.AT,
      CountryCode.ES,
      CountryCode.FR,
      CountryCode.CZ,
      CountryCode.SK,
      CountryCode.RO,
      CountryCode.HU,
    ],
  },
  [FeatureFlagKey.PRODUCT_RESULTING_LIST]: {
    enabled: false,
  },
};
